// Local translations
export const T = {
  en_GB: {
    toggleTheme: "Toggle theme",
  },
  nb_NO: {
    toggleTheme: "Bytt tema",
  },
} as const;
